/**
 * botanicalPrints — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const botanicalPrintsPack: ToilePack = {
    slug: 'botanical-prints',
    category: 'botanical',
    name: 'Botanical prints',
    tagline: tagline('prints', 'specimens', 'styles'),
    chips: chips('specimens', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'fern', label: 'Fern', subject: 'one full frond, unfurling fiddleheads and a spore-bearing detail'},
        {key: 'meadow', label: 'Wildflower meadow', subject: 'poppies, cornflowers, yarrow and grasses as a loose bunch'},
        {key: 'citrus', label: 'Citrus', subject: 'two lemons and a cut half, with blossom and glossy leaves'},
    ],
    styles: [
        {key: 'plate', label: 'Scientific plate', style: 'vintage scientific plate, fine engraved linework', palette: 'muted hand-tinted washes on aged paper', framing: 'centered specimen, Latin name beneath'},
        {key: 'line', label: 'Minimal line', style: 'minimal line, a single continuous hairline', palette: 'black on pure white, no fill', framing: 'centered specimen, generous margin'},
        {key: 'watercolor', label: 'Watercolor', style: 'watercolor, layered translucent washes', palette: 'soft bleeding edges, white paper ground', framing: 'centered specimen, generous margin'},
    ],
    directions: ['an olive branch instead', 'in muted sage tones', 'a pressed herbarium look'],
}
